import { useState, useEffect, useContext, useRef } from 'react'

import './index.less';
import Header from './Header';
import { useSize } from 'ahooks';
import { toPng } from '../../utils/helper/helper';
import { Redirect, Route, Switch } from "react-router-dom";
import Login from './Login';
import Home from './Home';
export default function Main(props) {
    const [style, setStyle] = useState();
    const rootRef = useRef();
    const size = useSize(rootRef)

    useEffect(() => {
        // let screenSize = defaultSize;
        // if (!screenSize) {
        let screenSize = [1920, 1080]
        // }
        // screenSize[1] = (document.body.offsetHeight / document.body.offsetWidth) * screenSize[0];
        screenSize[0] = (document.body.offsetWidth / document.body.offsetHeight) * screenSize[1];
        // console.log(rootRef?.current?.offsetWidth / rootRef?.current?.offsetHeight)
        if (size) {
            const { width, height } = size;
            const resw = screenSize[0] / width;
            const resh = screenSize[1] / height;
            let res = Math.max(resw, resh);

            let scale = 1 / res;

            const realWidth = screenSize[0] * scale;
            const realHeight = screenSize[1] * scale;

            let left = (width - realWidth) / 2;
            let top = (height - realHeight) / 2;
            setStyle({
                transform: `scale(${scale})`,
                left: left,
                top: top,
                scale,
                width: screenSize[0],
                height: screenSize[1],
                transformOrigin: '0 0',
                pointerEvents: "none",
                background: `url(${toPng('bg1')})`,
                backgroundSize: 'auto 100%',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat'
            })
        }
    }, [size]);

    return <div className='main relative' ref={rootRef}>
        {style && <div className='layout-v' style={style}>
            <div className='header layout-h' style={{
                pointerEvents: "auto",
                background: `url(${toPng('titlebg')})`,
                backgroundSize: '100% 100%'
            }}>
                <Header rootRef={rootRef} />
            </div>
            <div className='fill h0 layout-v'>
                <Switch>
                    <Redirect exact path="/main" to={"/main/home"}></Redirect>
                    <Route exact path="/main/home" component={Home}></Route>
                    <Route exact path="/main/login" component={Login}></Route>
                </Switch>
            </div>
        </div>}
    </div>;
}
